<template>
  <div :class="from!='introDetail'?'box3':'box3 no-padding'">
    <pageTitle
      title="AI赋能千行百业<br/>引领企业数字化和智能化转型势不可挡"
      text="- 大数据与AI协同 助力数字中国建设 -"
    />
    <div class="swiper-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <img :src= "require(`../../../assets/coursePage/pythonData/box3/pythonbox1pic${index + 1}.png`)"/>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
       from:'',
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 20,
        // effect: "left",
      },
      list: [
        {
          img:require('../../../assets/coursePage/pythonData/box3/pythonbox1pic1.png')
        },
        {
          img:require('../../../assets/coursePage/pythonData/box3/pythonbox1pic1.png')
        },
        {
          title: "薪资高于普通开发",
          money: "31756",
          unit: "元/月",
          text: "3~5年经验的大数据工程师在全国范<br />围内的平均月薪为31756元/月",
          tip: "数据来自：猎聘",
        },
      ],
    };
  },
    mounted() {
   this.from=this.getQueryString("from")
  },
};
</script>

<style lang="less" scoped>
.box3 {
  position: relative;
  width: 100%;
  background: linear-gradient(180deg, #e7f8ff 0%, #dbf4ff 100%);
  overflow: hidden;
  padding-top: 200px;
  .delta {
    margin: 48px auto 0;
    width: 287px;
    height: 111px;
    background: url("../../../assets/coursePage/pythonData/box3/block.png")
      no-repeat;
    background-size: cover;
  }

  .swiper-box {
    position: relative;
   
  }
  .swiper-slide {
    width: 564px;
    height: 691px;
    // background: rgba(245, 252, 255, 0.5);
  }

  .block {
    margin-top: 28px;
   
    width: 564px;
    height: 621px;
   img{
    width: 100%;
   }
    
    box-sizing: border-box;
  }

  .swiper-pagination-box3 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    // background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    margin: 0px 4px;
    width: 10px;
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
}
.no-padding{
   padding-top: 80px;
}
</style>
